// collection-zoom v6
(function () {

  let didScroll = false;
  let touchStartY = 0;

  document.addEventListener('touchstart', e => {
    touchStartY = e.touches[0].clientY;
    didScroll = false;
  }, { passive: true });

  document.addEventListener('touchmove', e => {
    if (Math.abs(e.touches[0].clientY - touchStartY) > 8) {
      didScroll = true;
    }
  }, { passive: true });

  // capture: true fires BEFORE the theme's touchend handler
  document.addEventListener('touchend', e => {
    if (!didScroll) return;
    const link = e.target.closest('.card-wrapper.product-card-wrapper a.full-unstyled-link');
    if (!link) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    didScroll = false;
  }, { capture: true, passive: false });

})();
